import { IGroupObject } from 'src/models/objectManagement';
import { Input, InputAdornment, Stack } from '@mui/material';
import TableGroupObject from 'src/components/GroupObject/Table';
import { useAppSelector } from 'src/app/hooks';
import { useFiltersByName } from 'src/hooks/useFiltersByName';
import SearchIcon from '@mui/icons-material/Search';
import useDebounceCallback from 'src/hooks/useDebounceCallback';
import { useFormikContext } from 'formik';
import { IFormValues } from './ModalCreateCustomDashboard';

const SelectGroupsSection = () => {
  const { setFieldValue, values } = useFormikContext<IFormValues>();
  const { groupObject } = useAppSelector((state) => state.objectManagement);
  const { filteredList, handleFilter } = useFiltersByName<IGroupObject>(
    groupObject.data
  );

  const handleChangeSearch = useDebounceCallback((searchValue: string) => {
    handleFilter(searchValue);
  });

  const handleClickRow = (group: IGroupObject) => {
    const isAllGroupClicked = group.id === 'all';
    const isGroupSelected = isAllGroupClicked
      ? values.objectGroups.length === groupObject.data.length
      : values.objectGroups.some((g) => g.id === group.id);

    if (isAllGroupClicked) {
      if (isGroupSelected) {
        // Unselect all - clear the selection
        setFieldValue('objectGroups', []);
      } else {
        // Select all - set to groupObject.data only
        setFieldValue('objectGroups', groupObject.data);
      }
      return;
    }

    // Handle individual group selection
    if (isGroupSelected) {
      // Remove the group from selection
      const updatedGroups = values.objectGroups.filter(
        (g) => g.id !== group.id
      );
      setFieldValue('objectGroups', updatedGroups);
    } else {
      // Add the group to selection
      setFieldValue('objectGroups', [...values.objectGroups, group]);
    }
  };

  return (
    <Stack gap={2}>
      <Input
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        }
        fullWidth
        placeholder="Search Source"
        onChange={(event) => handleChangeSearch(event.target.value)}
        onKeyDown={(e) => {
          e.stopPropagation();
        }}
      />
      <TableGroupObject
        groupObjects={[
          {
            displayName: 'All Group',
            id: 'all',
            name: 'All Group',
            objectList: [],
            isDefault: false
          },
          ...filteredList
        ]}
        loading={groupObject.loading}
        initialSelectedGroups={values.objectGroups}
        onClick={handleClickRow}
      />
    </Stack>
  );
};

export default SelectGroupsSection;
